import {
	appendSVGBtn,
	headeraddClass,
} from '@js/common/all-function.js';
import deviceMenu from '@js/common/deviceMenu.js';
import {
	initAOS,
} from '@js/common/aos.js';

deviceMenu();
initAOS();

/* Script on ready
------------------------------------------------------------------------------*/
/* Use jQuery code Start */
(function ($) {

	$('.sub-menu li.current-menu-item').each(function () {
		// Find the parent li and add the class
		$(this).closest('li.menu-item-has-children').addClass('current_page_parent');
	});

	$(document).ready(function () {
		$('.custom-select').each(function () {
			var $this = $(this);
			var select = $(this).find("select");
			select.select2({
				minimumResultsForSearch: -1,
				dropdownParent: $this,
			});
		});
	});
	$("video source").each(function () {
		var sourceFile = $(this).attr("data-src");
		if (typeof sourceFile !== 'undefined' && sourceFile !== false) {
			$(this).attr("src", sourceFile);
			$(this).removeAttr("data-src");
			var video = this.parentElement;
			video.load();
			var autoplay = $(this).parent().attr('autoplay');
			if (typeof autoplay !== 'undefined' && autoplay !== false) {
				video.play();
			}
		}
	});
})(jQuery);
/* Use jQuery code End */

document.addEventListener('DOMContentLoaded', () => {

	/* Global Anchor */
	document.addEventListener('click', function (e) {
		const a = e.target.closest('a');
		if (!a) return;

		const href = a.getAttribute('href');
		if (href && href.trim() === '#') {
			e.preventDefault();
			e.stopPropagation();
		}
	});
	/* Global Anchor */

	/* Process buttons */
	document.querySelectorAll('.btn , .btn-arrow').forEach(function (element) {
		const iconTarget = element.querySelector('i');
		if (iconTarget) {
			appendSVGBtn(iconTarget, '#icon-arrow-right-long', '24', '24');
		}
	});
	const dwnldBtns = document.querySelectorAll(".btn.-download");

	dwnldBtns.forEach(btn => {
		// Prevent duplicate append if SVG already exists
		if (!btn.querySelector("svg")) {
			btn.insertAdjacentHTML("beforeend", `
        <svg aria-hidden="true" width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><use xlink:href="#icon-download"></use></svg>`);
		}
	});
	/* Process buttons End */

	/* Show search bar on click start */
	const searchButton = document.querySelector('header.main-header .search-btn');
	const searchWrap = document.querySelector('header.main-header .mh-main-search');
	const body = document.body;
	const mainHeader = document.querySelector('header.main-header');

	window.resetSearch = function () {
		searchButton.classList.remove('is-click');
		searchWrap.classList.remove('is-open');
		body.classList.remove('search-open');
		mainHeader.classList.remove('header-pinned');
	};

	searchButton.addEventListener('click', function () {
		if (typeof window.resetHamburger === "function") {
			window.resetHamburger();
		}

		this.classList.toggle('is-click');
		searchWrap.classList.toggle('is-open');
		body.classList.toggle('search-open');

		setTimeout(() => {
			const searchInput = searchWrap.querySelector('input[type="search"]');
			if (searchInput) {
				searchInput.focus();
			}
		}, 100);
		mainHeader.classList.remove('header-pinned');
	});
	/* Show search bar on click end */

	/* Social Icon Start*/
	document.querySelectorAll('a').forEach(function (element) {
		if (element.classList.contains('heateor_sss_button_linkedin')) {
			appendSVGBtn(element, '#icon-linkedin', '22', '22');
		} else if (element.classList.contains('heateor_sss_button_x')) {
			appendSVGBtn(element, '#icon-x', '20', '19');
		} else if (element.classList.contains('heateor_sss_facebook')) {
			appendSVGBtn(element, '#icon-facebook', '11', '22');
		} else if (element.classList.contains('heateor_sss_more')) {
			appendSVGBtn(element, '#icon-share', '16', '23');
		}
	});
	document.querySelectorAll('.post-hero-section .heateor_sss_sharing_ul > a').forEach(function (el) {
		el.removeAttribute('style');
	});
	/* Social Icon end */

	document.querySelectorAll('.navigation ul li ul li.menu-item > a').forEach(function (link) {
		if (!link.querySelector('span')) {
			const text = link.textContent.trim();
			const span = document.createElement('span');
			span.setAttribute('data-title', text);
			span.textContent = text;
			link.textContent = '';
			link.appendChild(span);
		}
	});

	/* Job Listing Select */
	// document.querySelectorAll(".job-listing select").forEach(select => {
	// 	resizeSelect(select);
	// 	select.addEventListener("change", () => resizeSelect(select));
	// });
	/* Job Listing Select */

	/* All Function Start */
	headeraddClass();
	checkContentHeight();
	/* All Function End */
});

// Script on resize
window.addEventListener('resize', () => {
	/* All Function Start */
	headeraddClass();
	checkContentHeight();
	/* All Function End */
});

/* Script all functions
------------------------------------------------------------------------------*/

function checkContentHeight() {
	const header = document.querySelector('header.main-header');
	const mainContent = document.querySelector('.main-content');
	const wrapper = document.querySelector('.wrapper');

	if (!header || !mainContent || !wrapper) {
		return;
	}

	const windowHeight = window.innerHeight;
	const availableHeight = windowHeight;
	const mainContentHeight = mainContent.offsetHeight;
	if (mainContentHeight < availableHeight) {
		wrapper.classList.add('short-content');
	} else {
		wrapper.classList.remove('short-content');
	}
}


// function resizeSelect(select) {
// 	const tempSpan = document.createElement("span");
// 	document.body.appendChild(tempSpan);

// 	tempSpan.style.font = window.getComputedStyle(select).font;
// 	tempSpan.style.visibility = "hidden";
// 	tempSpan.style.whiteSpace = "nowrap";

// 	tempSpan.textContent = select.options[select.selectedIndex].text;

// 	select.style.width = (tempSpan.offsetWidth + 25) + "px";

// 	tempSpan.remove();
// }